import { jsx as _jsx } from "react/jsx-runtime";
import { Survey as UISurvey } from "@jti/ui";
export const Survey = (props) => (_jsx("div", { hidden: !props.isInEditor, children: _jsx(UISurvey, { ...props }) }));
